import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _typeof from '@babel/runtime/helpers/typeof';

var classnames = function classnames() {
  for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
    classes[_key] = arguments[_key];
  }

  return classes.reduce(function (acc, current) {
    if (!current) {
      return acc;
    }

    if (typeof current === 'string') {
      acc.push(current);
    }

    if (!!current && _typeof(current) === 'object') {
      var classNames = Object.entries(current).reduce(function (acc, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            className = _ref2[0],
            isActive = _ref2[1];

        if (isActive) {
          acc.push(className);
        }

        return acc;
      }, []).join(' ');
      acc.push(classNames);
    }

    return acc;
  }, []).join(' ');
};

export { classnames };
